import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import TooltipStatus from '../tooltips/TooltipStatus';

const GraficoStatus = ({ dadosGraficoStatus }) => {
  return (
    <div className="space-y-6">
      <div className="rounded-lg p-4 mb-4 bg-[color:var(--surface-muted)] border border-[color:var(--border)]">
        <h4 className="text-sm font-medium text-[color:var(--text-primary)] mb-2 inline-flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-[color:var(--status-warn,var(--accent))]" />
          Status das Contas por Conta Bancária
        </h4>
        <p className="text-xs text-[color:var(--text-muted)]">
          Distribuição de contas por status: vencidas, próximas ao vencimento, pagas e em aberto
        </p>
      </div>
      
      {/* Legenda para Status */}
      <div className="flex flex-wrap gap-3 justify-center mb-4">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--status-bad,var(--accent))] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Vencidas</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--status-warn,var(--accent))] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Próximas</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-yellow-500 rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Vencem Hoje</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--status-good,var(--accent))] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Pagas/Parcialmente</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--accent)] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Em Aberto</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--text-muted)] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Canceladas</span>
        </div>
      </div>
      
      <div className="h-80">
        {dadosGraficoStatus.length === 0 ? (
          <div className="h-full flex items-center justify-center border border-dashed border-[color:var(--border)] rounded-lg bg-[color:var(--surface-muted)]">
            <p className="text-sm text-[color:var(--text-muted)]">Sem dados de status para exibir.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dadosGraficoStatus} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" />
              <XAxis 
                dataKey="nome" 
                angle={-45}
                textAnchor="end"
                height={80}
                fontSize={12}
              />
              <YAxis />
              <Tooltip content={<TooltipStatus />} />
              <Bar dataKey="vencidas" fill="var(--status-bad, #EF4444)" name="Vencidas" />
              <Bar dataKey="proximasVencimento" fill="var(--status-warn, #F59E0B)" name="Próximas" />
              <Bar dataKey="hoje" fill="#FBBF24" name="Hoje" />
              <Bar dataKey="pagas" fill="var(--status-good, #10B981)" name="Pagas" />
              <Bar dataKey="pagasParcialmente" fill="var(--status-good, #10B981)" name="Parcialmente" />
              <Bar dataKey="emAberto" fill="var(--chart-1, #3B82F6)" name="Em Aberto" />
              <Bar dataKey="canceladas" fill="var(--text-muted, #6B7280)" name="Canceladas" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default GraficoStatus;




